import React from 'react';

class StarRating extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
  }

  componentWillUnmount() {
  }

  render() {

    var ret = null;

    if (this.props.rating) {
      var r = this.props.rating;
      if (r.comment_count && r.rating > 0) {
        var lis = [];
        [0, 1, 2, 3, 4].forEach((i, j) => {
          var cn = "fas fa-star";
          var rating = r.rating / 2;
          if ((rating - i) <= 0.19) {
            cn = "far fa-star";
          } else if ((rating - i) > 0 && (rating - i) <= 0.65) {
            cn = "fas fa-star-half-alt";
          }
          lis.push(
            <li key={"rating-" + j}>
              <i className={cn}></i>
            </li>
          );
        });
        ret = (
          <ul className="rating">
            {lis}
          </ul>
        );
      }
    }

    return ret;
  }
}

export { StarRating }
